import Select from "react-select";
import { transformDataIntoValueLabel } from "_utils";

export const OfferStatusDropdown = (props) => {
  const { onOfferStatusChange } = props;
  const statuses = [
    { title: "Approved", value: "approved" },
    { title: "Declined", value: "declined" },
  ];

  const handleChange = (inputValue) => {
    const val = inputValue ? inputValue.value : "all";
    onOfferStatusChange(val);
  };

  return (
    <Select
      placeholder={`Select Status`}
      isClearable={true}
      defaultOptions={false}
      options={transformDataIntoValueLabel(statuses, "title", "value")}
      onChange={handleChange}
    />
  );
};
